module.exports = __webpack_public_path__ + "img/nt127-01-81-1.prt.2ad22eaf.jpg";